/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseMetaNotificationResponse } from '../models/api-response-meta-notification-response';
import { getNotifications } from '../fn/meta-notification-api/get-notifications';
import { GetNotifications$Params } from '../fn/meta-notification-api/get-notifications';
import { markAllAsRead } from '../fn/meta-notification-api/mark-all-as-read';
import { MarkAllAsRead$Params } from '../fn/meta-notification-api/mark-all-as-read';
import { markAsRead } from '../fn/meta-notification-api/mark-as-read';
import { MarkAsRead$Params } from '../fn/meta-notification-api/mark-as-read';

@Injectable({ providedIn: 'root' })
export class MetaNotificationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `markAsRead()` */
  static readonly MarkAsReadPath = '/v1/api/ui/meta-notification/{reference}/read';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAsRead$Response(params: MarkAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return markAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAsRead(params: MarkAsRead$Params, context?: HttpContext): Observable<void> {
    return this.markAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `markAllAsRead()` */
  static readonly MarkAllAsReadPath = '/v1/api/ui/meta-notification/mark-all-read';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markAllAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAllAsRead$Response(params?: MarkAllAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return markAllAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markAllAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAllAsRead(params?: MarkAllAsRead$Params, context?: HttpContext): Observable<void> {
    return this.markAllAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNotifications()` */
  static readonly GetNotificationsPath = '/v1/api/ui/meta-notification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotifications$Response(params: GetNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMetaNotificationResponse>> {
    return getNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotifications(params: GetNotifications$Params, context?: HttpContext): Observable<ApiResponseMetaNotificationResponse> {
    return this.getNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseMetaNotificationResponse>): ApiResponseMetaNotificationResponse => r.body)
    );
  }

}
